<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading"
      >
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{
            $t("_GroupUserManagement")
          }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>

      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" class="d-flex flex-wrap justify-end gap-2">
            
              <v-btn
                v-if="canAdd"
                color="primary"
                class="control-btn create-btn"
                variant="elevated"
                size="large"
                prepend-icon="mdi-plus-circle"
                rounded="xl"
                @click="Adddialog = true"
              >
                <span class="btn-text">{{ $t("add") }}</span>
              </v-btn>

            </v-col>
          </v-row>
        </v-card-text>

        <v-data-table-server
          :items="dataTable"
          :items-per-page="options.itemsPerPage"
          :items-length="searchTotalTable"
          v-model:options="options"
          :headers="headers"
          :loading="loadingTable"
          class="modern-data-table modern-table"
          :hover="true"
          fixed-header
        >

          <!-- No Data Template -->
          <template v-slot:no-data>
            <div class="text-center pa-8">
              <v-icon size="64" color="grey-lighten-2">mdi-database-off</v-icon>
              <div class="text-h6 text-grey-darken-1 mt-4">{{ $t('noDataAvailable') }}</div>
              <div class="text-body-2 text-grey">{{ $t('tryDifferentSearch') }}</div>
            </div>
          </template>

          <!-- Group Name Column -->
          <template v-slot:item.groupName="{ item }">
            <div class="group-name-cell">
              <div class="cell-content">
                <div class="text-content">
                  <div class="primary-text">{{ item.groupName }}</div>
                  <div class="secondary-text" v-if="item.groupID">
                    ID: {{ item.groupID }}
                  </div>
                </div>
              </div>
            </div>
          </template>

          <!-- Model Group Column -->
          <template v-slot:item.groupModelName="{ item }">
            <div class="model-group-cell">
              <v-chip
                v-if="item.groupModelName && item.groupModelName !== '-'"
                size="default"
                variant="outlined"
                color="purple"
                class="model-group-chip"
              >
                <v-icon size="16" class="mr-1">mdi-layers</v-icon>
                {{ item.groupModelName }}
              </v-chip>
              <v-chip
                v-else
                size="default"
                variant="tonal"
                color="grey"
                class="no-data-chip"
              >
                <v-icon size="16" class="mr-1">mdi-minus</v-icon>
                No Group
              </v-chip>
            </div>
          </template>

          <template v-slot:item.modelDisplayName="item">
            <td style="text-align: start">
              {{ substring(item.item.modelDisplayNameTable) }}
              <v-btn
                icon
                variant="text"
                density="comfortable"
                v-show="item.item.modelDisplayNameTable != '-'"
                @click="Detail(item)"
                  class="detail-btn"
              >
                <v-icon size="22" color="info">mdi-magnify</v-icon>
                  <v-tooltip activator="parent" location="top">
                    View Details
                  </v-tooltip>
              </v-btn>
            </td>
          </template>

          <!-- Status Sync Column -->
          <template v-slot:item.statusSyncEntraID="{ item }">
            <div class="status-cell">
              <v-chip
                :color="item.statusSyncEntraID ? 'success' : 'error'"
                variant="tonal"
                size="default"
                class="status-chip"
              >
                <v-icon 
                  :icon="item.statusSyncEntraID ? 'mdi-check-circle' : 'mdi-close-circle'"
                  size="16"
                  class="mr-1"
                ></v-icon>
                {{ item.statusSyncEntraID ? 'Synced' : 'Not Synced' }}
              </v-chip>
            </div>
          </template>

          <!-- Actions Column (ยังคงเหมือนเดิม) -->
          <template v-slot:item.actions="{ item }">
            <div class="action-group" style="justify-content: center;">
              <!-- Edit -->
              <v-btn
                v-if="canEdit || isViewOnly"
                variant="text"
                density="comfortable"
                @click="Edit(item)"
                class="action-btn edit-btn"
                icon
              >
                <v-icon size="18">{{ canEdit ? 'mdi-pencil-outline' : 'mdi-eye-outline' }}</v-icon>
                <v-tooltip activator="parent" location="top">
                  {{ canEdit ? 'Edit' : 'View' }}
                </v-tooltip>
              </v-btn>
              <!-- Custom Divider -->
              <div v-if="canEdit && canDelete" class="action-divider"></div>

              <!-- Delete -->
              <v-btn
                v-if="canDelete"
                variant="text"
                density="comfortable"
                @click="Delete(item)"
                class="action-btn delete-btn"
                icon
              >
                <v-icon size="18">mdi-delete-outline</v-icon>
                <v-tooltip activator="parent" location="top">
                  Delete
                </v-tooltip>
              </v-btn>
            </div>
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>
    <!-- AddUserDialog -->
    <v-dialog v-model="Adddialog" max-width="900px" persistent class="modern-dialog">
      <v-card class="dialog-card">
        <!-- Dialog Header -->
        <div class="dialog-header dialog-header-add">
          <div class="header-main">
            <div class="header-icon-container">
              <div class="icon-background">
                <v-icon size="28" color="white">mdi-account-group-outline</v-icon>
              </div>
            </div>
            <div class="header-text-content">
                <h3 class="dialog-title">{{ $t("Group") }}</h3>
                <p class="dialog-subtitle">Create or manage group settings</p>
              </div>
          </div>
          <div class="header-actions">
            <v-btn
                icon
                variant="text"
                @click="Adddialog = false"
                color="white"
                class="close-button"
              >
                <v-icon >mdi-close</v-icon>
              </v-btn>
          </div>
          <!-- <div class="header-content">
            <div class="header-left">
              <v-icon size="28" color="white" class="mr-3">mdi-account-group-outline</v-icon>
              <div class="header-text">
                <h3 class="dialog-title">{{ $t("Group") }}</h3>
                <p class="dialog-subtitle">Create or manage group settings</p>
              </div>
            </div>
            <div class="header-right">
              <v-btn
                icon
                variant="text"
                @click="Adddialog = false"
                class="close-btn"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </div>
          </div> -->
        </div>

        <!-- Dialog Content -->
        <v-card-text class="dialog-content">
          <v-container fluid>
            <!-- Basic Information Section -->
            <div class="form-section">
              <div class="section-header">
                <v-icon color="primary" class="mr-2">mdi-information-outline</v-icon>
                <h4 class="section-title">Basic Information</h4>
              </div>
              
              <v-row class="section-content">
                <!-- Group Name -->
                <v-col cols="12" md="6">
                  <div class="form-field">
                    <v-text-field
                      ref="groupName"
                      :label="$t('Group Name')"
                      v-model="add.groupName"
                      required
                      :rules="[rules.required]"
                      variant="outlined"
                      density="comfortable"
                      class="modern-field"
                      hide-details="auto"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="20" color="primary">mdi-account-group</v-icon>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>

                <!-- Group ID -->
                <v-col cols="12" md="6">
                  <div class="form-field">
                    <v-text-field
                      ref="groupID"
                      :label="$t('Group ID')"
                      v-model="add.groupID"
                      required
                      variant="outlined"
                      density="comfortable"
                      class="modern-field"
                      hide-details="auto"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="20" color="primary">mdi-identifier</v-icon>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
            </div>

            <!-- Divider -->
            <v-divider class="section-divider"></v-divider>

            <!-- Model Configuration Section -->
            <div class="form-section">
              <div class="section-header">
                <v-icon color="purple" class="mr-2">mdi-robot-outline</v-icon>
                <h4 class="section-title">Model Configuration</h4>
                <!-- <v-chip size="small" variant="tonal" color="purple" class="ml-2">
                  Optional
                </v-chip> -->
              </div>
              
              <v-row class="section-content">
                <!-- Model Grouping -->
                <v-col cols="12" md="6">
                  <div class="form-field">
                    <v-autocomplete
                      :label="'Model Grouping'"
                      :items="listDDGroupModel"
                      item-title="name"
                      item-value="id"
                      clearable
                      variant="outlined"
                      density="comfortable"
                      v-model="add.groupModelID"
                      class="modern-field"
                      hide-details="auto"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="20" color="purple">mdi-layers</v-icon>
                      </template>
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }">
                            <v-icon
                              size="18"
                              color="info"
                              v-bind="props"
                              class="info-icon"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("_InfoSelectGroupModel") }}</span>
                        </v-tooltip>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>

                <!-- Model Selection -->
                <v-col cols="12" md="6">
                  <div class="form-field">
                    <v-autocomplete
                      :label="'Model'"
                      :items="filterListDDModel"
                      chips
                      closable-chips
                      item-title="name"
                      item-value="modelDisplayID"
                      multiple
                      variant="outlined"
                      density="comfortable"
                      clearable
                      v-model="add.modelDisplay"
                      class="modern-field"
                      hide-details="auto"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="20" color="purple">mdi-robot</v-icon>
                      </template>
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }">
                            <v-icon
                              size="18"
                              color="info"
                              v-bind="props"
                              class="info-icon"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("_InfoSelectModel") }}</span>
                        </v-tooltip>
                      </template>
                      <template v-slot:chip="{ props, item }">
                        <v-chip
                          v-bind="props"
                          size="small"
                          variant="tonal"
                          color="purple"
                          class="model-chip"
                        >
                          <v-icon size="14" class="mr-1">mdi-robot</v-icon>
                          {{ item.title }}
                        </v-chip>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
              </v-row>

              <!-- Model Selection Info -->
              <v-row v-if="add.modelDisplay && add.modelDisplay.length > 0">
                <v-col cols="12">
                  <div class="selection-info">
                    <v-icon color="success" class="mr-2">mdi-check-circle</v-icon>
                    <span class="info-text">
                      {{ add.modelDisplay.length }} model(s) selected
                    </span>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card-text>

        <!-- Dialog Actions -->
        <v-card-actions class="dialog-actions">
          <div class="actions-content">
            <div class="actions-left">
              <v-chip
                v-if="add.groupName"
                size="small"
                variant="tonal"
                color="success"
                class="status-chip"
              >
                <v-icon size="14" class="mr-1">mdi-check</v-icon>
                Ready to save
              </v-chip>
            </div>
            
            <div class="actions-right">
              <v-btn
                variant="outlined"
                color="grey"
                @click="Adddialog = false"
                class="dialog-action-btn cancel-btn"
              >
                <v-icon class="mr-2">mdi-close</v-icon>
                {{ $t("close") }}
              </v-btn>
              
              <v-btn
                v-if="canAdd"
                variant="elevated"
                @click="Save"
                class="dialog-action-btn save-btn-add"
                :disabled="!add.groupName"
              >
                <v-icon class="mr-2">mdi-content-save</v-icon>
                {{ $t("save") }}
              </v-btn>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Detail Dialog -->
    <v-dialog v-model="Detaildialog" max-width="600px" persistent class="modern-dialog">
      <v-card class="dialog-card">
        <!-- Dialog Header -->
        <div class="dialog-header dialog-header-add">
          <div class="header-main">
            <div class="header-icon-container">
              <div class="icon-background">
                <v-icon size="28" color="white">mdi-robot-outline</v-icon>
              </div>
            </div>
            <div class="header-text-content">
               <h3 class="dialog-title">{{ $t("modelName") }}</h3>
                <p class="dialog-subtitle">Model details and information</p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn
                icon
                variant="text"
                @click="Detaildialog = false"
                class="detail-close-btn"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
          </div>
        </div>

        <!-- Dialog Content -->
        <v-card-text class="detail-content">
          <div class="models-container">
            <!-- Empty State -->
            <div v-if="TempModel.length === 0" class="empty-state">
              <v-icon size="64" color="grey-lighten-2">mdi-robot-off</v-icon>
              <div class="text-h6 text-grey-darken-1 mt-4">No models found</div>
              <div class="text-body-2 text-grey">No model data available to display</div>
            </div>

            <!-- Model List -->
            <div v-else class="model-list">
              <div
                v-for="(item, index) in TempModel"
                :key="item.id"
                class="model-item"
                :class="{ 'last-item': index === TempModel.length - 1 }"
              >
                <div class="model-card">
                  <div class="model-content">
                    <div class="model-info">
                      <div class="model-icon-wrapper">
                        <v-icon size="24" color="primary">mdi-robot</v-icon>
                      </div>
                      <div class="model-details">
                        <h4 class="model-name">{{ item.name }}</h4>
                      </div>
                    </div>
                    
                    <div class="model-actions">
                      <v-btn
                        variant="outlined"
                        color="primary"
                        size="small"
                        class="view-btn"
                        @click="View(item)"
                      >
                        <v-icon size="16" class="mr-1">mdi-eye</v-icon>
                        View
                      </v-btn>
                    </div>
                  </div>
                </div>
                
                <!-- Divider (except for last item) -->
                <v-divider
                  v-if="index < TempModel.length - 1"
                  class="model-divider"
                ></v-divider>
              </div>
            </div>
          </div>
        </v-card-text>

        <!-- Dialog Actions -->
        <v-card-actions class="detail-actions">
          <div class="detail-actions-content">
            <div class="actions-left">
              <v-chip
                v-if="TempModel.length > 0"
                size="small"
                variant="tonal"
                color="info"
                class="summary-chip"
              >
                <v-icon size="14" class="mr-1">mdi-information</v-icon>
                {{ TempModel.length }} models
              </v-chip>
            </div>
            
            <div class="actions-right">
              <v-btn
                variant="outlined"
                color="grey"
                @click="Detaildialog = false"
                class="dialog-action-btn close-action-btn"
              >
                <v-icon class="mr-2">mdi-close</v-icon>
                {{ $t("close") }}
              </v-btn>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Loading Pleas Wait -->
    <!-- <v-overlay v-model="dialog">
      <v-dialog v-model="dialog" persistent width="300">
        <v-card color="#1976D2" dark>
          <v-card-text class="white--text">
            Loading Please Wait...
            <v-progress-linear
              indeterminate
              color="#FAA91B"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay> -->

    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>

    <v-dialog v-model="flagTemplate" max-width="800px">
      <v-card>
        <v-card-title>
          <p class="headline" style="color: #1d4f81">Template User</p>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-data-table-server
              :items="dataTemplate"
              :headers="headersTemplate"
              loading-text="Loading..."
              hide-default-footer
              disable-sort
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td style="text-align: center">
                    <v-btn icon @click="linkDownload(item.CSV)">
                      <v-tooltip top open-delay="500">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on"> mdi-file</v-icon>
                        </template>
                        <span>User - CSV</span>
                      </v-tooltip>
                    </v-btn>
                  </td>
                  <td style="text-align: center">
                    <v-btn icon @click="linkDownload(item.Excel)">
                      <v-tooltip top open-delay="500">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-file-excel</v-icon
                          >
                        </template>
                        <span>User - Excel</span>
                      </v-tooltip>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table-server>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="flagTemplate = false">{{
            $t("close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :model-value="dialog" class="align-center justify-center">
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>

<script>
import LogTrace from "@/api/function.js";
import { mask } from "vue-the-mask";
export default {
  name: "GroupUserManagement",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  mixins: [LogTrace],
  directives: {
    mask,
  },
  data() {
    return {
      mask: "##########",
      show1: false,
      filters: {
        username: [],
        email: [],
        employeeName: [],
        userType: [],
      },
      numberRules: [(v) => !!v || "Input is required!"],
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 10 || "Min 10 numbers",
      },
      Email: null,
      gg: null,
      UserType: null,
      dialog: false,
      add: {
        groupName: null,
        groupID: null,
        groupModelID: null,
        modelDisplay: null,
      },
      searchGroupModel: null,
      listDDGroupModel: [],
      searchModel: null,
      listDDModel: [],
      Adddialog: false,
      isSearch: false,
      username: "",
      email: "",
      totalTable: 0,
      itemsPerPage: 10,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      today: null,
      userListDDL: [],
      userList: [],
      headers: [],
      secretKey: "01234567890123456789012345678901",
      isFirst: true,
      searchTotalTable: 0,
      sortBy: [],
      sortDesc: [],
      DDQuickModel: [],
      accept:
        "text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      fileImportUser: null,
      flagTemplate: false,
      dataTemplate: [
        {
          CSV: "CSV",
          Excel: "Excel",
        },
      ],
      flagSyncSSO: false,
      dataTable: [],
      TempModel: [],
      Detaildialog: false,
      loadingTable: false,
      //tempUserWarning: {},
    };
  },
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
    searchGroupModel(val) {
      this.GetGroupModel(val);
    },
    searchModel(val) {
      this.GetModel(val);
    },
    Adddialog: {
      handler(val) {
        let self = this;
        if (val == false) {
          self.CloseAdddialog();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    let self = this;
    // self.dialog = true;
    self.loadingTable = true;
    self.headers = [
      {
        title: self.$t("no"),
        align: "center",
        sortable: false,
        value: "number",
      },
      { title: self.$t("groupname"), sortable: true, value: "groupName" },
      {
        title: self.$t("modelGroup"),
        sortable: false,
        value: "groupModelName",
      },
      {
        title: self.$t("modelName"),
        sortable: false,
        value: "modelDisplayName",
      },
      {
        title: self.$t("statusSync"),
        align: "center",
        sortable: false,
        value: "statusSyncEntraID",
      },
      {
        title: self.$t("action"),
        align: "center",
        sortable: false,
        value: "actions",
        width: "150px",
      },
    ];
    Promise.all([this.GetDate(), this.GetGroupModel(), this.GetModel()]).then(
      () => {
        this.dialog = false;
      }
    );
  },
  computed: {
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('GroupUserManagement');
    },
    canAdd() {
      return !!(this.$pagePermission && this.$pagePermission.canAdd('GroupUserManagement'));
    },
    canEdit() {
      return !!(this.$pagePermission && this.$pagePermission.canEdit('GroupUserManagement'));
    },
    canDelete() {
      return !!(this.$pagePermission && this.$pagePermission.canDelete('GroupUserManagement'));
    },
    filterListDDModel() {
      const data = this.listDDModel.filter((item, index, array) => {
        return array.findIndex(obj => obj.modelDisplayID === item.modelDisplayID) === index;
      });
      return data
    },
    filteredUsers() {
      return this.userList.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
    headersTemplate() {
      return [
        { text: "CSV", align: "center" },
        { text: "Excel", align: "center" },
      ];
    },
  },

  methods: {
    getHeaderIcon(columnValue) {
      const iconMap = {
        'number': 'mdi-counter',
        'groupName': 'mdi-account-group',
        'groupModelName': 'mdi-layers',
        'modelDisplayName': 'mdi-robot',
        'statusSyncEntraID': 'mdi-sync',
        'actions': 'mdi-cog'
      }
      return iconMap[columnValue] || null
    },

    getSortIcon(columnValue) {
      if (!this.options.sortBy || this.options.sortBy[0]?.key !== columnValue) {
        return 'mdi-sort'
      }
      return this.options.sortBy[0]?.order === 'desc' ? 'mdi-sort-descending' : 'mdi-sort-ascending'
    },

    getDisplayRange() {
      const start = (this.options.page - 1) * this.options.itemsPerPage + 1
      const end = Math.min(this.options.page * this.options.itemsPerPage, this.searchTotalTable)
      return `${start}-${end}`
    },
    View(item) {
      let self = this;
      const routeData = self.$router.resolve({
        name: "GPTModelDetail",
        query: {
          id: item.id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    Detail(temp) {
      let self = this;
      let item = temp.item;
      self.TempModel = [];
      self.Detaildialog = true;
      let dataLoop = item.modelDisplayName.split(", ");
      for (const element of dataLoop) {
        const name = element;
        const id = name.split(":")[1];
        let temp = {
          name: name.split(":")[0],
          id: id,
        };
        self.TempModel.push(temp);
      }
    },
    substring(text) {
      if (text != null) {
        if (text.length > 50) {
          return text.substring(0, 50) + "...";
        }
        return text;
      }
      return text;
    },
    CloseAdddialog() {
      let self = this;
      self.add = {
        groupName: null,
        groupID: null,
        groupModelID: null,
        modelDisplay: null,
      };
      self.Adddialog = false;
    },
    Save() {
      let self = this;
      if (
        self.add.groupName != null &&
        self.add.groupName != "" &&
        ((self.add.groupModelID != null && self.add.groupModelID != "") ||
          (self.add.modelDisplay != null && self.add.modelDisplay != ""))
      ) {
        self.dialog = true;
        let temp = {
          groupName: self.add.groupName,
          groupObject_ID: self.add.groupID,
          groupModelID: self.add.groupModelID,
          modelDisplayID:
            self.add.modelDisplay != null
              ? JSON.stringify(self.add.modelDisplay)
              : null,
        };
        self.$call.AddSecurityGroup(
          temp,
          (dataResponse) => {
            self.Adddialog = false;
            self.dialog = false;
            if (dataResponse.data == "Successfully") {
              self.Get();
              self.$swal.fire({
                icon: "success",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
            } else {
              self.$swal.fire({
                icon: "warning",
                title: dataResponse.data,
                showConfirmButton: false,
                timer: 1500,
              });
            }
          },
          (err) => {
            self.dialog = false;

            self.$swal.fire({
              icon: "alert",
              title: err,
              showConfirmButton: false,
              timer: 1500,
            });
            console.log(err);
          }
        );
      } else {
        if (
          self.add.groupName == null ||
          (self.add.groupName == "" &&
            (self.add.groupModelID == null || self.add.groupModelID == "") &&
            (self.add.modelDisplay == null ||
              self.add.modelDisplay == "" ||
              self.add.modelDisplay == [] ||
              self.add.modelDisplay == "null"))
        ) {
          self.$swal.fire({
            icon: "warning",
            title: "Please fill the required fields!!!",
            showConfirmButton: false,
            timer: 1500,
          });
        } else if (
          (self.add.groupModelID == null || self.add.groupModelID == "") &&
          (self.add.modelDisplay == null ||
            self.add.modelDisplay == "" ||
            self.add.modelDisplay == [] ||
            self.add.modelDisplay == "null")
        ) {
          self.$swal.fire({
            icon: "warning",
            title: "Please select your model!!!",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      }
    },

    Delete(item) {
      let self = this;
      let id = item.id;
      try {
        self.$swal
          .fire({
            title: this.$t("ConfirmDeletion"),
            text: this.$t("confirmDeletionTableName"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.$call.DeleteSecurityGroup(
                id,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    self.Get();
                  }
                  self.dialog = false;
                },
                (err) => {
                  console.log(err);
                  self.dialog = false;
                }
              );
            }
          });
      } catch (err) {
        console.log(err);
      }
    },
    Get() {
      try {
        let self = this;
        // self.dialog = true;
        self.loadingTable = true;
        
        let { page, itemsPerPage, sortBy } = self.options;
        let sortField = null;
        let sortOrder = null;

        if (sortBy && sortBy.length > 0) {
          sortField = sortBy[0].key;
          sortOrder = sortBy[0].order === 'desc';
        }
        let temp = {
          page: self.isSearch ? 1 : page,
          perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
          sortDesc: sortOrder,
          sortBy: sortField,
        };
        self.$call.GetTableSecurityGroup(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.dataTable = dataResponse.data.data;
              self.searchTotalTable = dataResponse.data.total;
              self.totalTable = self.isFirst
                ? dataResponse.data.total
                : self.totalTable;
            } else {
              self.dataTable = [];
              (self.searchTotalTable = 0), (self.totalTable = 0);
            }
            // self.dialog = false;
            self.loadingTable = false;
            self.isFirst = false;
            self.isSearch = false;
          },
          (errorResource) => {
            // self.dialog = false;
            self.loadingTable = false;
            self.isSearch = false;
            if (errorResource.status != 0) {
              console.error(errorResource);
            }
          }
        );
      } catch (error) {
        // this.LogTrace(error, "Apply");
      }
    },

    GetInformationDefault() {
      try {
        let self = this;
        self.dialog = true;
        const { page, itemsPerPage } = this.options;
        let temp = {
          page: self.isSearch ? 1 : page,
          perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
          sortDesc: null,
          sortBy: null,
        };
        self.$call.GetTableUserChatManagement(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.searchTotalTable = dataResponse.data.total;
              self.userList = dataResponse.data.data;
              self.userListDDL = dataResponse.data.data;
              self.totalTable = self.isFirst
                ? dataResponse.data.total
                : self.totalTable;
            } else {
              self.userList = [];
              self.totalTable = 0;
              self.searchTotalTable = 0;
            }
            self.dialog = false;
            self.isSearch = false;
            self.isFirst = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.isSearch = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "Get");
      }
    },
    async GetModel() {
      let self = this;
      await self.$call.DDGPTModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listDDModel = dataResponse.data;
          } else {
            self.listDDModel = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    Search() {
      let self = this;
      self.isSearch = true;
      self.options.page = 1;
      self.GetInformationDefault();
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    GetGroupModel() {
      let self = this;
      self.$call.GetDDGroupModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listDDGroupModel = dataResponse.data;
          } else {
            self.listDDGroupModel = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },

    Edit(item) {
      let self = this;
      self.$router.push({
        name: "UserGroupDetail",
        query: {
          id: item.id,
        },
      });
    },
    GetDDModelQuickGroup() {
      let self = this;
      self.$call.GetDDModelQuickGroup(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDQuickModel = dataResponse.data;
          } else {
            self.DDQuickModel = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
  },
};
</script>
<style scoped>
/* Base Styles */
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
}

.title {
  color: white;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

/* Data Table Styles */
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}

/* Dialog Base Styles */
/* .modern-dialog, */
.detail-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
  max-height: 90vh;
}

.detail-dialog {
  max-height: 85vh;
}

/* Dialog Headers */
/* .dialog-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 24px !important;
  border-bottom: none;
}

.detail-header {
  background: linear-gradient(135deg, #4a90e2 0%, #357abd 100%);
  color: white;
  padding: 24px !important;
  border-bottom: none;
}

.header-content,
.detail-header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}

.header-left {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.header-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
} */

/* .dialog-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  color: white;
  letter-spacing: 0.025em;
} */

/* .detail-title {
  font-size: 1.4rem;
  font-weight: 700;
  margin: 0;
  color: white;
  letter-spacing: 0.025em;
} */

/* .dialog-subtitle, */
/* .detail-subtitle {
  font-size: 0.9rem;
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 400;
} */

/* .detail-subtitle {
  font-size: 0.85rem;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
} */

/* .close-btn, */
.detail-close-btn {
  background: rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

/* .close-btn:hover, */
.detail-close-btn:hover {
  background: rgba(255, 255, 255, 0.2) !important;
  transform: scale(1.05);
}

.count-chip {
  background: rgba(255, 255, 255, 0.2) !important;
  color: white !important;
  font-weight: 600;
  backdrop-filter: blur(10px);
}

/* Dialog Content */
.dialog-content {
  padding: 32px 24px !important;
  background: #fafafa;
  max-height: 60vh;
  overflow-y: auto;
}

.detail-content {
  padding: 0 !important;
  background: #fafafa;
  max-height: 50vh;
  overflow-y: auto;
}

.models-container {
  padding: 24px;
}

/* Form Sections */
.form-section {
  margin-bottom: 32px;
}

.form-section:last-child {
  margin-bottom: 0;
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 8px;
  border-bottom: 2px solid rgba(102, 126, 234, 0.1);
}

.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
  letter-spacing: 0.025em;
}

.section-content {
  margin-top: 16px;
}

.section-divider {
  margin: 24px 0;
  border-color: rgba(102, 126, 234, 0.2);
}

/* Form Fields */
.form-field {
  margin-bottom: 8px;
}

.modern-field {
  background: white;
  border-radius: 12px !important;
}

.modern-field :deep(.v-field) {
  border-radius: 12px !important;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.modern-field :deep(.v-field__input) {
  padding: 16px;
  font-size: 0.95rem;
}

.modern-field :deep(.v-label) {
  font-weight: 500;
  color: #6c757d;
}

.modern-field :deep(.v-field--focused .v-label) {
  color: #667eea !important;
}

/* Icons and Chips */
.info-icon {
  transition: all 0.2s ease;
  opacity: 0.7;
}

.info-icon:hover {
  opacity: 1;
  transform: scale(1.1);
}

.model-chip {
  font-weight: 500;
  letter-spacing: 0.025em;
  margin: 2px;
}

.status-chip,
.summary-chip {
  font-weight: 500;
  letter-spacing: 0.025em;
}

/* Selection Info */
.selection-info {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: rgba(76, 175, 80, 0.05);
  border: 1px solid rgba(76, 175, 80, 0.2);
  border-radius: 8px;
  margin-top: 8px;
}

.info-text {
  font-size: 0.9rem;
  color: #388e3c;
  font-weight: 500;
}

/* Dialog Actions */
.dialog-actions,
.detail-actions {
  padding: 20px 24px !important;
  background: white;
  border-top: 1px solid #e9ecef;
}

.actions-content,
.detail-actions-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.actions-left {
  display: flex;
  align-items: center;
}

.actions-right {
  display: flex;
  gap: 12px;
}

/* Buttons */
.dialog-action-btn {
  height: 44px;
  border-radius: 12px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.025em;
  transition: all 0.3s ease;
  min-width: 120px;
}

.detail-action-btn {
  height: 40px;
  border-radius: 12px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.025em;
  transition: all 0.3s ease;
  min-width: 100px;
}

.cancel-btn,
.close-action-btn {
  border: 2px solid #dee2e6 !important;
  color: #6c757d !important;
}

.cancel-btn:hover,
.close-action-btn:hover {
  border-color: #adb5bd !important;
  background: #f8f9fa !important;
  transform: translateY(-1px);
}

.save-btn {
  /* Primary button */
  color: white !important;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3) !important;
}

.save-btn:hover:not(:disabled) {
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4) !important;
  transform: translateY(-2px);
}

.save-btn:disabled {
  background: #e9ecef !important;
  color: #adb5bd !important;
  box-shadow: none !important;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #6c757d;
}

/* Model List and Cards */
.model-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.model-item {
  position: relative;
}

.model-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;
  width: 100%;
}

.model-card:hover {
  border-color: rgba(74, 144, 226, 0.2);
  box-shadow: 0 8px 25px rgba(74, 144, 226, 0.15);
  transform: translateY(-2px);
}

.model-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 16px;
}

.model-info {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  min-width: 0;
}

.model-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: rgba(74, 144, 226, 0.1);
  border-radius: 12px;
  border: 2px solid rgba(74, 144, 226, 0.2);
  flex-shrink: 0;
}

.model-details {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.model-name {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
  letter-spacing: 0.025em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.2;
}

.model-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
  align-items: center;
}

.view-btn {
  border-radius: 10px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.025em;
  transition: all 0.3s ease;
  min-width: 80px;
  height: 36px;
  white-space: nowrap;
}

.view-btn:hover {
  background: #4a90e2 !important;
  color: white !important;
  border-color: #4a90e2 !important;
  transform: scale(1.05);
}

.model-divider {
  margin: 10px 0;
  border-color: rgba(74, 144, 226, 0.9);
}

/* Scrollbar Styling */
.dialog-content::-webkit-scrollbar,
.detail-content::-webkit-scrollbar {
  width: 6px;
}

.dialog-content::-webkit-scrollbar-track,
.detail-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb,
.detail-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb:hover,
.detail-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Animations */
@media (prefers-reduced-motion: no-preference) {
  /* .modern-dialog, */
  .detail-dialog {
    animation: dialogSlideIn 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  }
  
  @keyframes dialogSlideIn {
    from {
      opacity: 0;
      transform: translateY(-30px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
  
  .model-card {
    animation: modelCardFadeIn 0.3s ease forwards;
  }
  
  @keyframes modelCardFadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
}

/* Focus States */
.view-btn:focus,
.detail-close-btn:focus,
.detail-action-btn:focus {
  outline: 2px solid #4a90e2;
  outline-offset: 2px;
}

/* Responsive Design */
@media (max-width: 960px) {
  /* .modern-dialog, */
  .detail-dialog {
    margin: 16px;
    max-width: calc(100vw - 32px) !important;
  }
  
  .dialog-header,
  .detail-header {
    padding: 20px !important;
  }
  
  /* .dialog-title {
    font-size: 1.3rem;
  } */
  
  .detail-title {
    font-size: 1.2rem;
  }
  
  /* .dialog-subtitle, */
  .detail-subtitle {
    font-size: 0.85rem;
  }
  
  .detail-subtitle {
    font-size: 0.8rem;
  }
  
  .dialog-content {
    padding: 24px 20px !important;
  }
  
  .models-container {
    padding: 20px;
  }
  
  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .actions-content,
  .detail-actions-content {
    flex-direction: column-reverse;
    gap: 12px;
    align-items: stretch;
  }
  
  .actions-right {
    justify-content: center;
  }
  
  .dialog-action-btn,
  .detail-action-btn {
    width: 100%;
  }
  
  .detail-header-content {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }
  
  .header-right {
    align-self: flex-end;
    width: 100%;
    justify-content: space-between;
  }
  
  .model-card {
    padding: 16px;
  }
  
  .model-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .model-info {
    width: 100%;
    justify-content: flex-start;
  }
  
  .model-actions {
    width: 100%;
    justify-content: center;
  }
  
  .view-btn {
    width: 100%;
    min-width: auto;
  }
}

@media (max-width: 600px) {
  .header-content {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }
  
  .header-right {
    align-self: flex-end;
  }
  
  /* .dialog-title {
    font-size: 1.2rem;
  } */
  
  .section-title {
    font-size: 1rem;
  }
  
  .modern-field :deep(.v-field__input) {
    padding: 14px;
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .model-icon-wrapper {
    width: 40px;
    height: 40px;
  }
  
  .model-name {
    font-size: 1rem;
  }
  
  .view-btn {
    height: 32px;
    font-size: 0.85rem;
  }
  
  .detail-action-btn {
    height: 36px;
    font-size: 0.9rem;
  }
}

/* Dark Theme Support */
/* .modern-dialog, */
.v-theme--dark 
.v-theme--dark .detail-dialog {
  background: #2d2d2d;
}

.v-theme--dark .dialog-content {
  background: #1e1e1e;
}

.v-theme--dark .detail-content {
  background: #1e1e1e;
}

.v-theme--dark .dialog-actions,
.v-theme--dark .detail-actions {
  background: #2d2d2d;
  border-top-color: #404040;
}

.v-theme--dark .models-container {
  background: #1e1e1e;
}

.v-theme--dark .modern-field {
  background: #2d2d2d;
}

.v-theme--dark .modern-field :deep(.v-field) {
  border-color: #404040;
}

.v-theme--dark .modern-field:focus-within :deep(.v-field) {
  border-color: #8a9cff !important;
}

.v-theme--dark .section-header {
  border-bottom-color: rgba(138, 156, 255, 0.2);
}

.v-theme--dark .section-divider {
  border-color: rgba(138, 156, 255, 0.2);
}

.v-theme--dark .section-title {
  color: #e0e0e0;
}

.v-theme--dark .selection-info {
  background: rgba(76, 175, 80, 0.1);
  border-color: rgba(76, 175, 80, 0.3);
}

.v-theme--dark .info-text {
  color: #81c784;
}

.v-theme--dark .model-card {
  background: #2d2d2d;
  border-color: #404040;
}

.v-theme--dark .model-card:hover {
  border-color: rgba(100, 181, 246, 0.3);
  box-shadow: 0 8px 25px rgba(100, 181, 246, 0.2);
}

.v-theme--dark .model-icon-wrapper {
  background: rgba(100, 181, 246, 0.1);
  border-color: rgba(100, 181, 246, 0.3);
}

.v-theme--dark .model-name {
  color: #e0e0e0;
}

.v-theme--dark .model-divider {
  border-color: rgba(100, 181, 246, 0.2);
}

.v-theme--dark .empty-state {
  color: #bbb;
}

.v-theme--dark .dialog-content::-webkit-scrollbar-track,
.v-theme--dark .detail-content::-webkit-scrollbar-track {
  background: #404040;
}

.v-theme--dark .dialog-content::-webkit-scrollbar-thumb,
.v-theme--dark .detail-content::-webkit-scrollbar-thumb {
  background: #666;
}

.v-theme--dark .dialog-content::-webkit-scrollbar-thumb:hover,
.v-theme--dark .detail-content::-webkit-scrollbar-thumb:hover {
  background: #777;
}

.modern-table :deep(.v-table__wrapper) {
  max-height: 600px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(25, 118, 210, 0.3) rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper thead th) {
  position: sticky;
  top: 0;
  z-index: 2;
  background: rgb(var(--v-theme-surface, 255, 255, 255));
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar) {
  width: 6px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-track) {
  background: rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb) {
  background: rgba(25, 118, 210, 0.3);
  border-radius: 3px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb:hover) {
  background: rgba(25, 118, 210, 0.5);
}
</style>
